import * as CONST from 'Reducers/Users/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

const initState = {
  users: [],
  userById: {},
  filterClient: null,
  filterStatus: CONST.USERS_SET_FILTER_STATUS[0].value,
  filterRole: null,
  usersSortBy: {
    columnName: null,
    reverse: false,
  },
  // This is a hash map of users with the key being the user id and the
  // value being the user data
  usersHashmap: {},
  loggedUser: {},
}

export function users(state = initState, action) {
  switch (action.type) {
    case CONST.CREATE_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users, action.payload.clientView],
      }

    case CONST.GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users,
      }

    case CONST.GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        userById: action.payload.userById,
      }

    case CONST.USERS_UPDATE_LOGGED_IN_USER:
      return {
        ...state,
        loggedUser: {
          ...state.loggedUser,
          ...action.payload,
        },
      }

    case CONST.USERS_SET_FILTER_CLIENT:
      return {
        ...state,
        filterClient: action.payload.clientId,
      }

    case CONST.USERS_SET_FILTER_STATUS:
      return {
        ...state,
        filterStatus: action.payload.status,
      }

    case CONST.USERS_SET_FILTER_ROLE:
      return {
        ...state,
        filterRole: action.payload.role,
      }

    case CONST.USERS_SET_SORT_BY:
      return {
        ...state,
        usersSortBy: action.usersSortBy,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...initState,
      }

    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS:
      var result = {
        ...state,
        usersHashmap: {
          ...state.usersHashmap,
          ...(() => {
            var usersHashmap = {}
            var cityPlans = action.result.data.campaign.cityPlans.nodes
            cityPlans.forEach(cityPlan => {
              cityPlan.missions.edges.forEach(({ node }) => {
                var user = node.user
                if (!user) return
                usersHashmap[user.id] = Object.assign(
                  {},
                  state.usersHashmap[user.id],
                  user,
                )
              })
            })
            return usersHashmap
          })(),
        },
      }
      return result

    default:
      return state
  }
}
